import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/AssignmentLateRounded';

class AssignmentLateRoundedIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default AssignmentLateRoundedIcon;
